import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = {
  id: "quiz-result",
  tabindex: "-1",
  "aria-label": "Quiz-Auswertung"
}
const _hoisted_2 = {
  key: 1,
  class: "result"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "column" }
const _hoisted_5 = { class: "emoji" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { key: 2 }
const _hoisted_9 = { key: 3 }
const _hoisted_10 = { class: "percent" }
const _hoisted_11 = { class: "question__title" }
const _hoisted_12 = { class: "question__type" }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 0,
  class: "question__code"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = {
  key: 1,
  class: "question__image"
}
const _hoisted_19 = ["src"]
const _hoisted_20 = ["aria-selected"]
const _hoisted_21 = {
  key: 2,
  class: "explanation"
}
const _hoisted_22 = {
  key: 3,
  class: "meta"
}

import { computed, nextTick, onMounted, ref } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useToast } from 'vue-toastification';
import { Quiz } from '@/models/Quiz';
import { QuizAnswer } from '@/models/QuizAnswer';
import { QuizQuestion } from '@/models/QuizQuestion';
import ConfettiExplosion from 'vue-confetti-explosion';


export default /*@__PURE__*/_defineComponent({
  __name: 'QuizResultComponent',
  props: {
    quizzes: {}
  },
  setup(__props: any) {

const router = useRouter();
const route = useRoute();

const props = __props;

const hasConfetti = ref(false);
const confetti = ref({
  stageHeight: window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight,
  stageWidth: (window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth) * 1.33,
});

const makeConfetti = async () => {
  hasConfetti.value = false;
  await nextTick();
  hasConfetti.value = true;
};

const isCorrect = (answer: QuizAnswer) => {
  return answer.correct ? answer.selected : !answer.selected;
};

const isSingleChoice = (question: QuizQuestion) => {
  return question.answers?.filter(answer => answer.correct).length === 1;
};

const code = (question: QuizQuestion) => {
  let code = '';

  question.code.lines.forEach(line => {
    code += `<span class="dive-code">${ line }</span><br />`;
  })

  return code;
};

const formatted = (questionText: string) => {
  return questionText.replace('___', '<span class="gap"></span>');
};

const quiz = computed(() => {
  return props.quizzes.find((quiz: Quiz) => quiz.id === route.params.id);
});

onMounted(() => {
  makeConfetti();
  if (quiz.value && quiz.value.score >= 50) {
    const toast = useToast();

    toast.success('Gut gemacht, weiter so! 🔥', {
      id: 'well-done',
    });
  }
});

return (_ctx: any,_cache: any) => {
  const _component_vue3_autocounter = _resolveComponent("vue3-autocounter")!
  const _directive_highlightjs = _resolveDirective("highlightjs")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    (hasConfetti.value)
      ? (_openBlock(), _createBlock(_unref(ConfettiExplosion), {
          key: 0,
          force: 0.7,
          particleCount: 200,
          particleSize: 14,
          duration: 4500,
          stageHeight: confetti.value.stageHeight,
          stageWidth: confetti.value.stageWidth
        }, null, 8, ["stageHeight", "stageWidth"]))
      : _createCommentVNode("", true),
    (quiz.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (quiz.value.score >= 85)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "🤩"))
                  : (quiz.value.score >= 75)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, "😍"))
                    : (quiz.value.score >= 50)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_8, "😊"))
                      : (_openBlock(), _createElementBlock("span", _hoisted_9, "🥳"))
              ]),
              _createElementVNode("span", _hoisted_10, [
                _createVNode(_component_vue3_autocounter, {
                  ref: "counter",
                  startAmount: 0,
                  endAmount: quiz.value.score || 0,
                  duration: 1,
                  prefix: "Dein Ergebnis: ",
                  suffix: "%",
                  decimals: 0,
                  autoinit: true
                }, null, 8, ["endAmount"])
              ]),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value.questions, (question, questionIndex) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "question",
                  key: questionIndex
                }, [
                  _createElementVNode("div", _hoisted_11, [
                    _createElementVNode("p", _hoisted_12, [
                      (isSingleChoice(question))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_13, "Single Choice"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_14, "Multiple Choice"))
                    ]),
                    _createElementVNode("h3", {
                      innerHTML: formatted(question.text)
                    }, null, 8, _hoisted_15)
                  ]),
                  (question.code)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                        _withDirectives((_openBlock(), _createElementBlock("pre", {
                          class: _normalizeClass(question.code.language)
                        }, [
                          _cache[1] || (_cache[1] = _createTextVNode("                ")),
                          _createElementVNode("code", {
                            class: "javascript",
                            innerHTML: code(question)
                          }, null, 8, _hoisted_17),
                          _cache[2] || (_cache[2] = _createTextVNode("\n              "))
                        ], 2)), [
                          [_directive_highlightjs]
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (question.image)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                        _createElementVNode("img", {
                          src: require(`@/assets/quiz/images/${quiz.value.id}/${question.image}`),
                          alt: ""
                        }, null, 8, _hoisted_19)
                      ]))
                    : _createCommentVNode("", true),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(quiz.value.questions[questionIndex].answers, (answer, answerIndex) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["question__answer result", {
                selected: answer.selected,
                correctAnswer: isCorrect(answer),
                wrongAnswer: !isCorrect(answer),
                singleChoice: isSingleChoice(question),
              }]),
                      "aria-selected": answer.selected,
                      key: answerIndex
                    }, _toDisplayString(answer.text), 11, _hoisted_20))
                  }), 128)),
                  (quiz.value.questions[questionIndex].explanation)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                        _createElementVNode("p", null, [
                          _cache[3] || (_cache[3] = _createElementVNode("strong", null, "Erklärung:", -1)),
                          _createTextVNode(" " + _toDisplayString(quiz.value.questions[questionIndex].explanation), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (quiz.value.questions)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                        _createElementVNode("small", null, [
                          _createElementVNode("strong", null, _toDisplayString(questionIndex + 1), 1),
                          _cache[4] || (_cache[4] = _createTextVNode(" von ")),
                          _createElementVNode("strong", null, _toDisplayString(quiz.value.questions.length), 1)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]))
              }), 128)),
              _createElementVNode("button", {
                class: "back",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'home' })))
              }, " Zurück zur Startseite ")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})